export const BUSINESS_UNITS_PAGE_TEST_ID = 'developers_business_units';
export const BUSINESS_UNITS_TITLE_TEST_ID =
  'developers_business_units_title-label';
export const BUSINESS_UNITS_SUBTITLE_TEST_ID =
  'developers_business_units_subtitle-label';

export const BUSINESS_UNITS_GRID_TEST_ID = 'developers_business_units_grid';
export const BUSINESS_UNIT_CARD_TEST_ID = (uuid: string) =>
  `developers_business_units_card-row-${uuid}`;
export const BUSINESS_UNIT_CARD_COPY_UUID_TEST_ID = (uuid: string) =>
  `developers_business_units_card_uuid-copy-btn-${uuid}`;
export const BUSINESS_UNIT_DEFAULT_BADGE_TEST_ID = (uuid: string) =>
  `developers_business_units_card_default-status-${uuid}`;

export const BUSINESS_UNITS_TITLE = 'Business units';
export const BUSINESS_UNITS_SUBTITLE =
  'Manage the business units used across your integration.';

export const BUSINESS_UNIT_UUID_FIELD_LABEL = 'Unique Identifier (UUID)';
export const BUSINESS_UNIT_DEFAULT_BADGE_LABEL = 'Default';

export const BUSINESS_UNITS_EMPTY_TEST_ID = 'developers_business_units_empty';
export const BUSINESS_UNITS_EMPTY_CTA_TEST_ID =
  'developers_business_units_empty_create-btn';
export const BUSINESS_UNITS_EMPTY_HEADING = 'No business units yet';
export const BUSINESS_UNITS_CREATE_LABEL = 'Create business unit';

export const BUSINESS_UNITS_HEADER_CREATE_TEST_ID =
  'developers_business_units_create-btn';
export const BUSINESS_UNITS_LOADING_TEST_ID =
  'developers_business_units_content-loading';
export const BUSINESS_UNITS_ERROR_TEST_ID =
  'developers_business_units_content-error';
export const BUSINESS_UNITS_ERROR_COPY =
  'Something went wrong loading your business units. Please try again.';

export const BUSINESS_UNITS_BATCH_ERROR_MESSAGE =
  'Something went wrong loading more business units.';
export const BUSINESS_UNITS_BATCH_ERROR_TOAST_KEY =
  'business-units-batch-error';
export const BUSINESS_UNITS_PAGE_SIZE = '50';

export const BUSINESS_UNITS_SCROLL_TEST_ID = 'developers_business_units_scroll';
export const BUSINESS_UNITS_BATCH_LOADING_TEST_ID =
  'developers_business_units_grid_batch-loading';

export const BUSINESS_UNITS_SEARCH_PLACEHOLDER = 'Search by name';
export const BUSINESS_UNITS_NO_MATCH_COPY =
  'No business units match your search.';
export const BUSINESS_UNITS_SEARCH_DEBOUNCE_MS = 400;
export const BUSINESS_UNITS_SEARCH_TEST_ID =
  'developers_business_units_search-input';
export const BUSINESS_UNITS_NO_MATCH_TEST_ID =
  'developers_business_units_search_no-match-label';
